var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ProjectIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 42
  }), React.createElement("path", {
    d: "M26 32.2609C29.4578 32.2609 32.2609 29.4578 32.2609 26C32.2609 22.5422 29.4578 19.7391 26 19.7391C22.5422 19.7391 19.7391 22.5422 19.7391 26C19.7391 29.4578 22.5422 32.2609 26 32.2609Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M26 0.956543C12.2261 0.956543 0.956543 12.2261 0.956543 26C0.956543 39.7739 12.2261 51.0435 26 51.0435C39.7739 51.0435 51.0435 39.7739 51.0435 26C51.0435 12.2261 39.7739 0.956543 26 0.956543ZM26 42.6957C16.8174 42.6957 9.30437 35.1826 9.30437 26C9.30437 16.8174 16.8174 9.30437 26 9.30437C35.1826 9.30437 42.6957 16.8174 42.6957 26C42.6957 35.1826 35.1826 42.6957 26 42.6957Z",
    fill: "black"
  }));
};
export var ProjectIconGlyph = function (props) {
  return React.createElement(ProjectIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};